import React from "react";
import { Link } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { EmailOutlined } from "@mui/icons-material";
import {
  Alert,
  Button,
  FormHelperText,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import ErrorAlert from "./Shared/ErrorAlert";
import SuccessCheck from "./Shared/Lottie/SuccessCheck";

import { useForgotPasswordMutation } from "store/services/userApi";

const INITIAL_STATE = {
  email: "",
};

const ForgotPasswordForm = () => {
  const signInButtonRef = React.useRef();

  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  // RTK Query
  const [forgotPassword, { data, isLoading: sendingLink, error }] =
    useForgotPasswordMutation();

  // methods
  const handleEnterPress = (e) => {
    if (e.key === "Enter")
      signInButtonRef?.current && signInButtonRef?.current?.click();
  };

  const handleSignIn = async (data) => {
    try {
      const res = await forgotPassword(data).unwrap();

      console.log(res);

      reset(INITIAL_STATE);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center p-6"
      onKeyDown={handleEnterPress}
    >
      {!!error && <ErrorAlert error={error} />}

      {!data ? (
        <div className="grid w-full max-w-md grid-cols-1 gap-8">
          <div>
            <div className="mb-4 text-center text-2xl font-semibold text-gray-700">
              Forgot Password?
            </div>

            <p className="text-gray text-center">
              Enter your email to reset your password.{" "}
            </p>
          </div>

          <div>
            <Controller
              name="email"
              control={control}
              rules={{ required: "Please provide your email." }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Email"
                  placeholder="Enter email you signed in with"
                  size="small"
                  type="email"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlined />
                      </InputAdornment>
                    ),
                  }}
                  className="rounded-lg"
                />
              )}
            />
            {errors.email && (
              <FormHelperText error className="text-sm text-red-500">
                {errors.email.message}
              </FormHelperText>
            )}
          </div>

          <div className="mt-2 text-center text-sm text-blue-700 hover:underline">
            <Link to="/sign-in">Remembered your password? Sign in</Link>
          </div>

          <LoadingButton
            size="large"
            loading={sendingLink}
            loadingIndicator="Sending..."
            variant="contained"
            className="mt-4 bg-blue-600 text-white hover:bg-blue-700"
            ref={signInButtonRef}
            onClick={handleSubmit((data) => handleSignIn(data))}
          >
            Send Reset Email
          </LoadingButton>
        </div>
      ) : (
        <>
          <Alert
            severity="success"
            className="mb-5 border-green-600 bg-green-100 text-green-700"
          >
            {data?.message ?? "Reset Link successfully sent!"}
          </Alert>

          <SuccessCheck />

          <Link to="/reset-password" className="mt-4">
            <Button
              variant="contained"
              size="large"
              className="w-full bg-green-600 text-white hover:bg-green-700"
            >
              Reset Password
            </Button>
          </Link>
        </>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
